'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ButtonToolbar2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/ButtonToolbar.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/ButtonToolbar.js
 ** module chunks = 0
 **/